var map = {
	"./svg/gps.svg": 5537,
	"./svg/headphones.svg": 6946,
	"./svg/homepage-decor-1.svg": 1633,
	"./svg/homepage-decor-2.svg": 882,
	"./svg/homepage-decor-top.svg": 8969,
	"./svg/phone.svg": 861,
	"./svg/spot-marker-dark.svg": 4063,
	"./svg/spot-marker-light.svg": 8269,
	"./svg/texture.svg": 7028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6742;